<template>
  <main class="main mobile_list" role="main" v-if="isCompleted">
    <div class="main_con internet_mobile_main_con" id="main_con">
      <div class="sub_main">
        <div class="h_tab">
          <ul>
            <li>
              <button @click="goList('InternetCommerce.List')">인터넷</button>
            </li>
            <li class="on"><button>휴대폰</button></li>
          </ul>
        </div>
        <div class="h_tab_cont" id="h_tab_cont">
          <div class="tab_sec">
            <div class="tab_sec_ttl">
              <h2>견적 요청 쿠폰</h2>
              <p>
                견적을 요청하고 나면 판매점으로부터 일주일간 견적을 모집해요
              </p>
            </div>
            <div class="tab_sec_cont" @click="goMobileMain(coupon.couponCnt)">
              <div class="coupon">
                <ul class="phone_cou">
                  <li>
                    <div v-if="coupon.chargeDay1 == 7" class="cover full"></div>
                    <div
                      v-else
                      class="cover"
                      :style="`height: ${couponCharge[coupon.chargeDay1]}%`"
                    ></div>
                  </li>
                  <!--다 채워졌을때 full 추가-->
                  <li>
                    <div v-if="coupon.chargeDay2 == 7" class="cover full"></div>
                    <div
                      v-else
                      class="cover"
                      :style="`height: ${couponCharge[coupon.chargeDay2]}%`"
                    ></div>
                  </li>
                  <li>
                    <div v-if="coupon.chargeDay3 == 7" class="cover full"></div>
                    <div
                      v-else
                      class="cover"
                      :style="`height: ${couponCharge[coupon.chargeDay3]}%`"
                    ></div>
                  </li>
                </ul>
                <div class="txt_area">
                  <h3>
                    총 <span>3개</span> 중에
                    <span>{{ coupon.couponCnt }}개</span> 남았어요!
                  </h3>
                  <p v-if="coupon.couponCnt == 3">견적을 요청해보세요 ></p>
                  <!--쿠폰이 3장 다 있을때 문구-->
                  <p v-else>
                    발행까지
                    {{ getRemainDay(coupon) }}일이 남았어요!
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="tab_sec">
            <div class="tab_sec_ttl">
              <h2>진행 중인 견적 요청</h2>
            </div>
            <div class="tab_sec_cont">
              <IngList
                :list="mobileRequestListIng"
                :isType="'list'"
                @goView="goView"
                @setSlideIndex="setSlideIndex"
              ></IngList>
            </div>
          </div>

          <div class="tab_sec" v-if="list.length > 0">
            <div class="tab_sec_ttl">
              <h2>마감 된 견적 요청</h2>
            </div>
            <div class="tab_sec_cont">
              <ul
                class="list_fini_progress"
                v-for="(item, index) in list"
                :key="index"
              >
                <EndList :item="item" @goView="goView"></EndList>
              </ul>
            </div>
          </div>
          <!--list_sec-->
          <infinite-loading
            ref="infiniteLoading"
            :direction="direction"
            :identifier="infiniteId"
            @infinite="infiniteHandler"
          >
            <span slot="no-more"></span>
            <span slot="no-results"></span>
            <span slot="spinner"></span>
          </infinite-loading>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import InfiniteLoading from 'vue-infinite-loading';
import * as util from '@common/lib/common/utils.js';

import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import {
  mapActions as internetMapActions,
  mapGetters as internetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

import IngList from '@/front/customer/views/mobile/components/IngList';
import EndList from '@/front/customer/views/mobile/components/EndList';

export default {
  name: 'Mobile.List',
  components: {
    IngList,
    EndList,
    InfiniteLoading,
  },
  data() {
    return {
      isCompleted: false,
      page: 1,
      size: 10,
      direction: 'top',
      infiniteId: 0,
      list: [],
      visitPage: 0, // 페이지 이동시 현재 페이지
      scrollLocation: 0, // 페이지 이동시 현재 스크롤 위치
      isVisitName: ['Mobile.View'], // 뒤로 이동시 가능한 방문 페이지 정리
      coupon: [],
      couponCharge: [0, 15, 30, 45, 60, 75, 90, 100],

      isSlideIndex: 0,
    };
  },
  async created() {
    await this.getMobileCoupon();
    await this.getRequestListIng();
    // await this.getRequestListEnd();
    this.isCompleted = true;
    // this.getMobileEstimateNewCnt();
    // this.getInternetCommerceUserQuotationNew();
  },
  async mounted() {
    this.infiniteId += 1; //리스트 가져오기.
  },
  // 페이지 이동시 호출됨, 여기서는 뒤로가기시 어디서 왔는지 체크
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      await vm.fetch(from.name);
    });
  },
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
    }),
    ...mobileMapGetters({
      mobileRequestListIng: mobileTypes.MOBILE_REQUEST_LIST_ING,
      mobileRequestListEnd: mobileTypes.MOBILE_REQUEST_LIST_END,
      mobileEstimateNewCnt: mobileTypes.MOBILE_ESTIMATE_NEW_CNT,
    }),
    ...internetMapGetters({
      internetCommercUserQuotationNewList:
        internetTypes.INTERNET_COMMERCE_USER_QUOTATION_NEW,
    }),
  },
  methods: {
    ...userMapActions([userTypes.FETCH_ME]),
    ...mobileMapActions([
      mobileTypes.SELECT_MOBILE_COUPON,
      mobileTypes.SELECT_MOBILE_REQUEST_LIST_ING,
      mobileTypes.SELECT_MOBILE_REQUEST_LIST_END,
      mobileTypes.SELECT_MOBILE_ESTIMATE_NEW_CNT,
    ]),
    ...internetMapActions([
      internetTypes.SELECT_INTERNET_COMMERCE_USER_QUOTATION_NEW,
    ]),
    async fetch(fromName) {
      // 뒤로가기로 왔을때 저장된 값 확인
      if (this.isVisitName.includes(fromName)) {
        let visit_page = await localStorage.getItem(
          'visit_mobile_list_from_detail',
        );

        if (visit_page) {
          visit_page = JSON.parse(visit_page);
          this.visitPage = visit_page.page;
          this.scrollLocation = visit_page.scrollLocation;

          // 데이터 담고 삭제
          await localStorage.removeItem('visit_mobile_list_from_detail');
        }
      }
    },
    async infiniteHandler($state) {
      const target = document.querySelector('#h_tab_cont');
      if (this.infiniteId == 0) {
        $state.complete();
      } else {
        this.direction = 'bottom';
        await this.getRequestListEnd();

        if (this.page == 1) {
          this.list = [];
        }

        if (this.mobileRequestListEnd.content.length) {
          this.list.push(...this.mobileRequestListEnd.content);

          // 페이지 이동시 저장된 페이지 개수만큼 호출
          if (this.scrollLocation > 0) {
            setTimeout(() => {
              target.scrollTo(0, this.scrollLocation);
            }, 10);

            // 뒤로가기로 온 이후 페이지가 다 로딩이 되면 스크롤 저장 위치를 초기화
            setTimeout(() => {
              this.scrollLocation = 0;
            }, 1000);
          }

          this.page += 1;
          $state.loaded();
        } else {
          // 페이지 다 호출하면 저장된 위치로 이동
          $state.complete();
        }
      }
    },
    goList(link) {
      this.$router.push({
        name: link,
      });
    },
    async getMobileCoupon() {
      this.coupon = await this[mobileTypes.SELECT_MOBILE_COUPON]();
      console.log('this.coupon');
      console.log(this.coupon);
    },
    async getRequestListIng() {
      let params = {
        page: this.page,
        size: 10,
        callPart: 'CUSTOMER',
        status: 'ING',
      };
      await this[mobileTypes.SELECT_MOBILE_REQUEST_LIST_ING](params);

      console.log(params);

      console.log('mobileRequestListIng');
      console.log(this.mobileRequestListIng);
    },
    async getRequestListEnd() {
      let params = {
        page: this.page,
        size: this.size,
        callPart: 'CUSTOMER',
        status: 'END',
      };
      await this[mobileTypes.SELECT_MOBILE_REQUEST_LIST_END](params);

      console.log(params);

      console.log('mobileRequestListEnd');
      console.log(this.mobileRequestListEnd);
    },
    goMobileMain(couponCnt) {
      if (couponCnt == 0) {
        return;
      }

      this.$router.push({
        name: 'Mobile.Main',
      });
    },
    getRemainDay(coupon) {
      console.log('coupon');
      console.log(coupon);

      if (coupon.couponCnt == 2) {
        return 7 - Number(coupon.chargeDay3);
      } else if (coupon.couponCnt == 1) {
        return 7 - Number(coupon.chargeDay2);
      } else if (coupon.couponCnt == 0) {
        return 7 - Number(coupon.chargeDay1);
      }
    },
    goView(id, status) {
      const target = document.querySelector('#h_tab_cont');
      // // 페이지 이동 전에 세션스토리지에 저장 (뒤로가기 처리하기 위함) - 시작
      let scrollLocation = target.scrollTop; // 현재 스크롤바 위치
      const visit_page = {
        page: this.page,
        scrollLocation: scrollLocation,
      };

      localStorage.setItem(
        'visit_mobile_list_from_detail',
        JSON.stringify(visit_page),
      );
      // 페이지 이동 전에 세션스토리지에 저장 (뒤로가기 처리하기 위함) - 끝

      this.$router.push({
        name: 'Mobile.View',
        query: {
          id: id,
          status: status,
          isSlideIndex: this.isSlideIndex,
        },
      });
    },
    setSlideIndex(index) {
      this.isSlideIndex = index;
    },
  },
};
</script>
